// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___VvvtZ","root__button":"style-module__root__button___qHmZH","root__wrapper":"style-module__root__wrapper___ZkXmD","root__action":"style-module__root__action___wKYl1"};
    if(module.hot) {
      // 1729151132519
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  